<template>
	<core-layout-headline-with-tabs :tabs="tabs">{{
		$t("file_system")
	}}</core-layout-headline-with-tabs>
</template>

<script>
import CoreLayoutHeadlineWithTabs from "@/modules/core/components/CoreLayoutHeadlineWithTabs"

export default {
	components: { CoreLayoutHeadlineWithTabs },

	props: {
		bucketName: String
	},

	data() {
		return {
			tabs: [
				{
					name: this.$t("file_browser"),
					to: `/${this.$store.state.tenantId}/file-system/detail/${
						this.$route.params.id
					}`
				},
				{
					name: this.$t("settings"),
					to: {
						name: "FileSystemSettings",
						params: { id: this.$route.params.id }
					}
				},
				{
					name: this.$t("logs"),
					to: {
						name: "FileSystemLogs",
						params: { id: this.$route.params.id }
					}
				}
			]
		}
	}
}
</script>
